export default __webpack_public_path__ + "static/media/section4_bubble_right.be699704.png";